import React, { useContext, useMemo } from 'react';
import { CloudDownloadOutlined } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { CardExtraction } from '../../components/extractions/CardExtraction';
import { AuthContext } from '../../contexts/AuthContext';
import { encontrarModulo } from '../../helpers/encontrarModulo';
import { HeaderModule } from '../../components/home/HeaderModule';
import { TurnsForm } from '../../components/turns/extractions/TurnsForm';
import { useModalStore } from '../../store/useModalStore';

export const TailExtractions = () => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    const { openModal } = useModalStore();

    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'turnA')?.actions?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    const cards = [
        { 
            component: (
                <CardExtraction
                    title='Extracción de turnos'
                    description='Permite realizar la extracción de turnos atendidos en un rango de fechas determinado.'
                    action={ () => openModal(<TurnsForm />) }
                />
            )
        }
    ];

    return (
        <>
            <HeaderModule
                icon={ <CloudDownloadOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Extracciones'
            />

            <Grid container gap={2}>
                { actions?.map((a, i) => a && <div key={ a?.name }>{ cards[i]?.component }</div> )}
            </Grid>
        </>
    )
}